exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navigation__mobile__link {\n  font-size: 200%;\n  display: none; }\n\n@media screen and (max-width: 688px) {\n  .navigation__mobile__link {\n    display: block;\n    float: right;\n    padding: 20px; } }\n\n@media screen and (min-width: 688px) {\n  .navigation--sans-title .navigation__title {\n    display: none; } }\n\n.wishmenu-btn {\n  font: normal 14px/ 20px \"Texta Narrow\", Helvetica, Arial, sans-serif;\n  font-size: 100%;\n  color: #222;\n  text-decoration: none;\n  padding: 0 12px; }\n  .wishmenu-btn aside {\n    vertical-align: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/layouts/header/header.component.scss
// module id = ../../../../../src-admin/app/layouts/header/header.component.scss
// module chunks = main